import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Id, MobileListRenderItemInfo } from 'drf-react-by-schema';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { Layout } from 'src/styles';
import CONSTANTS from 'src/constants/common';

import AsmubipButton from './AsmubipButton';
import { useAppSelector } from 'src/app/hooks';
import { FilterChip } from 'src/styles/styledComponents';

export default function EntrepostoCard({ item, id }: MobileListRenderItemInfo) {
  const { key } = useAppSelector((state) => state.page);
  const navigate = useNavigate();
  if (!key) {
    return null;
  }
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent
        sx={{
          ...Layout.productionCardContent,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}>
        <Box>
          <Box>{item.nome.valueStr}</Box>
          <Typography variant="body2">{item.municipio.valueStr}</Typography>
          {item.grupos_fornecedores && (
            <>
              <Typography variant="body2">Fornecedores:</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {item.grupos_fornecedores.value.map((grupo: { id: Id; label: string }) => (
                  <FilterChip key={grupo.id} label={grupo.label} />
                ))}
              </Box>
            </>
          )}
        </Box>
        {item.logomarca.value && (
          <img
            src={`${CONSTANTS.API.url}/${item.logomarca.value.url}`}
            style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 10 }}
          />
        )}
      </CardContent>
      <CardActions>
        <Box sx={Layout.productionCardActionWrapper}>
          <AsmubipButton
            variant="outlined"
            size="medium"
            onClick={() => {
              navigate(`/${key}/view/${id}`);
            }}>
            Ver
          </AsmubipButton>
          <AsmubipButton
            variant="contained-dark"
            size="medium"
            onClick={() => {
              navigate(`/${key}/edit/${id}`);
            }}>
            Editar
          </AsmubipButton>
        </Box>
      </CardActions>
    </Card>
  );
}
